export const QUESTIONS = [
  {
    text: "What are you making room for in your life?",
    answers: [
      { text: "The freedom to choose my own direction.", pillar: "freedom" },
      { text: "Something new, even if it starts messy.", pillar: "chaos" },
      { text: "Being honest about what matters to me.", pillar: "truth" },
      { text: "The strength to keep going.", pillar: "grit" },
      { text: "A life beyond other people's expectations.", pillar: "rebellion" },
      { text: "Lessons I can carry forward.", pillar: "wisdom" },
    ],
  },
  {
    text: "When life gets difficult, what pulls you forward?",
    answers: [
      { text: "Remembering I can choose a different path.", pillar: "freedom" },
      { text: "Finding possibility in the unexpected.", pillar: "chaos" },
      { text: "Facing what is really happening.", pillar: "truth" },
      { text: "Taking the next step, however small.", pillar: "grit" },
      { text: "Refusing to let the usual rules define me.", pillar: "rebellion" },
      { text: "Remembering what experience has taught me.", pillar: "wisdom" },
    ],
  },
  {
    text: "What would you want your artwork to remind you?",
    answers: [
      { text: "You have room to become yourself.", pillar: "freedom" },
      { text: "Something beautiful can emerge from the mess.", pillar: "chaos" },
      { text: "Your truth deserves to be seen.", pillar: "truth" },
      { text: "Keep showing up for your journey.", pillar: "grit" },
      { text: "You can write a different story.", pillar: "rebellion" },
      { text: "Carry the light and lessons forward.", pillar: "wisdom" },
    ],
  },
];

export const PILLAR_RESULTS = {
  freedom: {
    artworkTitle: "Do Not Worry About Tomorrow",
    explanation: "You're making room to breathe, choose, and move forward on your own terms.",
  },
  chaos: {
    artworkTitle: "The Ache in Bloom",
    explanation: "You're open to finding possibility and beauty while things are still taking shape.",
  },
  truth: {
    artworkTitle: "The Inner Atlas",
    explanation: "You're drawn to honesty, self-understanding, and expression that feels like you.",
  },
  grit: {
    artworkTitle: "Trust the Process",
    explanation: "You're choosing steady steps and the courage to keep showing up.",
  },
  rebellion: {
    artworkTitle: "Dance in the Downpour",
    explanation: "You're ready to question the script and make room for your own way.",
  },
  wisdom: {
    artworkTitle: "Thank You for the Light",
    explanation: "You're carrying forward the people, lessons, and light that shaped you.",
  },
};

export const ARTWORK_PRODUCT_MATCH = {
  "Thank You for the Light": "Thank You for the Light Canvas",
  "The Inner Atlas": "The Inner Atlas Canvas Print",
};

export const scoreQuiz = (answers) => {
  const scores = {};
  answers.forEach((a) => {
    if (a) scores[a.pillar] = (scores[a.pillar] || 0) + 1;
  });
  const max = Math.max(...Object.values(scores));
  const tied = Object.keys(scores).filter((p) => scores[p] === max);
  for (let i = answers.length - 1; i >= 0; i--) {
    if (answers[i] && tied.includes(answers[i].pillar)) return answers[i].pillar;
  }
  return tied[0];
};

export const slugify = (title) => title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const wallpaperFilename = (title) => `threads-unbound-${slugify(title)}-wallpaper.jpg`;
